<div class="card">
  <h2 class="card-title">Academic progress reports</h2>
  <div class="card-body">
    <div class="card-actions">
      <button type="button" class="btn btn-primary" (click)="openForm()">
        <i class="fas fa-plus"></i> Submit a progress report
      </button>
      <button type="button" class="btn btn-secondary btn-sm" (click)="load()">
        <i class="fas fa-sync"></i> Refresh
      </button>
    </div>

    @if (error()) {
      <div class="alert alert-warning"><i class="fas fa-exclamation-circle"></i> {{ error() }}</div>
    }
    @if (message()) {
      <div class="alert alert-success"><i class="fas fa-check-circle"></i> {{ message() }}</div>
    }

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Reference</th>
            <th>Report</th>
            <th>Period</th>
            <th>Average</th>
            <th>Submitted</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="7" class="empty-cell"><i class="fas fa-spinner fa-spin"></i> Loading progress reports…</td></tr>
          }
          @if (!loading() && reports().length === 0) {
            <tr><td colspan="7" class="empty-cell">You have not submitted a progress report yet.</td></tr>
          }
          @for (report of reports(); track report.id) {
            <tr>
              <td>{{ report.referenceNumber }}</td>
              <td>
                <strong>{{ report.title }}</strong>
                @if (report.scholarshipTitle) { <small>{{ report.scholarshipTitle }}</small> }
              </td>
              <td>{{ report.academicPeriod || report.cycle }}</td>
              <td>{{ report.averageScore !== null && report.averageScore !== undefined ? (report.averageScore | number: '1.2-2') : '—' }}</td>
              <td>{{ report.submittedDate | date: 'mediumDate' }}</td>
              <td>
                <span [class]="statusClass(report.status)">{{ report.status }}</span>
                @if (report.reviewerFeedback) {
                  <small class="feedback-note">{{ report.reviewerFeedback }}</small>
                }
              </td>
              <td>
                @if (report.documentObjectKey) {
                  <button type="button" class="btn btn-secondary btn-sm" (click)="download(report)">Download record</button>
                } @else {
                  <span class="empty-cell">No record attached</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (showForm()) {
  <div class="modal-backdrop" (click)="closeForm()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Submit an academic progress report</h2>
        <button class="modal-close" (click)="closeForm()"><i class="fas fa-times"></i></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="form" class="form-grid">
          <label>
            Title
            <input type="text" formControlName="title" placeholder="e.g. Semester 1 2026 progress" />
          </label>

          <label>
            Reporting period
            <input type="text" formControlName="academicPeriod" placeholder="e.g. Semester 1 2026" />
          </label>

          <label>
            Institution
            <input type="text" formControlName="institutionName" />
          </label>

          <label>
            Average mark / GPA
            <input type="number" step="0.01" formControlName="averageScore" />
          </label>

          <label>
            Progress summary
            <textarea rows="4" formControlName="summary"></textarea>
          </label>

          <div class="upload-block">
            <label class="upload-label">
              Academic record (optional)
              <input type="file" (change)="onFileSelected($event)" [disabled]="uploading()" />
            </label>
            @if (uploading()) {
              <small><i class="fas fa-spinner fa-spin"></i> Uploading…</small>
            }
            @if (document(); as attached) {
              <small><i class="fas fa-paperclip"></i> {{ attached.fileName }}</small>
            }
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeForm()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="busy() || uploading()">
          {{ busy() ? 'Submitting…' : 'Submit report' }}
        </button>
      </div>
    </div>
  </div>
}
